import { BUSINESS_PLAN_TYPES, IBusinessToolType } from 'constants/businessPlan';
import { ITextItem } from 'PDF/components/PdfContentText';
import { PDF_SECTIONS } from 'PDF/constants/sections';
import { MagazineTextItemType } from 'PDF/helpers/pdfAlgorithm/types';
import { StageStatusEnum } from 'PDF/types/timeline';

import { IBusinessToolForm } from 'components/BusinessToolForm/utils/form';

export type ObjectType = Record<string, any>;

export interface IInfoImg {
  imgSrc: string;
}

export interface IInfoTableRow {
  id: string;
  title: string;
  info: string | string[] | IInfoImg;
  iconSrc?: string;
}

export const getMagazineTextObject = (subHeadingText: string, text: string) =>
  ({
    subHeadingText,
    text,
  }) as MagazineTextItemType;

export const divideDataBetweenTables = (rows: any[], key: string) => {
  const length = rows[0][key].length;
  const amount = length === 4 ? 2 : 3;
  const n = Math.ceil(length / amount);
  const arrays = new Array(n > 1 ? n : 1).fill('').reduce((result, current, index) => {
    const step = index === 0 ? 0 : index * amount;
    result.push(
      rows.map((row) => ({ ...row, [key]: row[key].slice(step, step > length ? length - 1 : step + amount) })),
    );
    return result;
  }, []);

  return arrays;
};

export const checkIsEmptyData = (arrayOfData: (number | string)[][]) => {
  for (const data of arrayOfData) {
    if (data.find((value) => value)) {
      return false;
    }
  }

  return true;
};

export const checkIsEmptyDataByKey = (arrayOfData: any[], key: string, excludeFirstArrayItem = false) => {
  for (const item of arrayOfData) {
    const values = item[key] && excludeFirstArrayItem ? item[key].slice(1) : item[key];

    if (
      Array.isArray(values) &&
      (values as (string | number)[]).find(
        (value) =>
          !['0%', '', '0', '0.0', '0.00', '0 months', '—', 'NaN'].includes(String(value)) &&
          (Number(value) > 0 || !!String(value)),
      )
    ) {
      return false;
    }
  }

  return true;
};

export const convertToNumber = (value: string | number | undefined) => {
  if (value === 'NaN') {
    return 0;
  } else {
    return +(+(value || 0)).toFixed(1);
  }
};

export const prepareSectionId = <V extends PDF_SECTIONS>(type: IBusinessToolType, sectionId: V): V | `${V}Investor` =>
  type === BUSINESS_PLAN_TYPES.FOR_INVESTORS ? `${sectionId}Investor` : sectionId;

export const prepareId = (type: IBusinessToolType, sectionId: PDF_SECTIONS, id: string): string =>
  `${prepareSectionId(type, sectionId)}.${id}`;

export const getStages = (businessPlanChapters: IBusinessToolForm) => {
  const { stages } = businessPlanChapters.IMPLEMENTATION_PLAN;

  return stages
    .map(({ from, to, stage, status }) => ({
      startDate: from,
      endDate: to,
      stage,
      status: status?.value as StageStatusEnum,
    }))
    .filter(({ startDate, endDate }) => startDate && endDate);
};

export const isMagazineItemsNotEmpty = (items?: ITextItem[]) => !items?.every((item) => !item.text);
